import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgPin = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 15" {...props}>
    <path
      d="M5.838 8.542 2.66 5.364l3.899-.72 3.703-3.091.233-1.082 3.46 3.46-1.12.195L9.756 7.84l-.732 3.887zm1.569 1.602-6.911 3.89L4.359 7.18z"
      fill="none"
      stroke="#919499"
    />
  </svg>
);
const Memo = memo(SvgPin);
export default Memo;
